import InquiryCallbackService from 'Main/service/InquiryCallbackService'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { getRefreshToken } from 'variables/common'
import JsonViewerPanel from 'views/components/JsonViewer/JsonViewerPanel'
import { InquiryCallbackSummary } from './widget/InquiryCallbackSummary'
import { CatchError } from 'Exceptions/exceptions'


function InquiryCallbackDetails () {
  const { id } = useParams()

  const navigate = useNavigate()

  const refreshToken = getRefreshToken()

  const inquiryCallbackService = useMemo(
    () => new InquiryCallbackService(),
    []
  )

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const [data, setData] = useState(null)

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)

      const res = await inquiryCallbackService.getById(id)

      setData(res.data)
    } catch (err) {
      const caught = CatchError(err, navigate, refreshToken)

      if (caught !== undefined) { setError('Failed to load inquiry callback.') }
    } finally {
      setLoading(false)
    }
  }, [id, inquiryCallbackService, navigate, refreshToken])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  if (loading) return <>Loading...</>

  if (!data) return null

  return (
        <>
            <div className="page-heading">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <h3>Inquiry Callback Details</h3>

                        <p className="text-subtitle text-muted">
                            Trx ID <code>{data.trxId}</code>
                        </p>
                    </div>

                    <div className="col-md-6 text-md-end">
                        <button
                            className="btn btn-light"
                            onClick={() => navigate('/dashboard/inquiry-callback')}
                        >
                            Back
                        </button>
                    </div>
                </div>
            </div>

            <div className="page-content">

                {error && (
                    <div className="alert alert-danger">
                        {error}
                    </div>
                )}

                <InquiryCallbackSummary data={data} />

                <div className="card mt-3">
                    <div className="card-header">
                        Callback Information
                    </div>

                    <div className="card-body">

                        <div className="row">

                            {[
                              ['Device Name', data.device_name],
                              ['Inquiry Type', data.inquiryType],
                              ['Partner Service ID', data.partnerServiceId],
                              ['Virtual Account No', data.virtualAccountNo],
                              ['Virtual Account Name', data.virtualAccountName]
                            ].map(([label, value]) => (
                                <div className="col-md-4 mb-3" key={label}>
                                    <div className="text-muted small mb-1">{label}</div>
                                    <div className="fw-semibold text-break">{value || '—'}</div>
                                </div>
                            ))}

                        </div>

                    </div>
                </div>

                <div className="row mt-3">

                    <div className="col-lg-6">
                        <JsonViewerPanel
                            title="Request Payload"
                            data={data.request_payload}
                        />
                    </div>

                    <div className="col-lg-6">
                        <JsonViewerPanel
                            title="Response Payload"
                            data={data.response_body}
                        />
                    </div>

                </div>

            </div>
        </>
  )
}

export default InquiryCallbackDetails
